
import { defineComponent } from "vue";

export default defineComponent({
    name: "AppSection",
    props: {
        padding: { type: [Number, String], default: "5" }
    }
});
